import React from 'react';
import {Switch, Route} from 'react-router-dom';
import {Form} from 'api';
import Block from './blockId';
import NormalBlocks from './NormalBlocks';

interface Props {
  form: Form;
}

export default ({form}: Props) => {
  return (
    <Switch>
      <Route path="/form/forms/:formId/:page/blocks/:blockId">
        <Block form={form} />
      </Route>
      <Route path="/form/forms/:formId/:page/blocks">
        <NormalBlocks />
      </Route>
    </Switch>
  );
};
